// Styles for ReorderButtons component
// Add styled components here if needed in the future

import { Box } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const ButtonContainer = styled(Box)<{ canClick: boolean }>`
  cursor: ${({ canClick }) => (canClick ? 'pointer' : 'not-allowed')};
  opacity: ${({ canClick }) => (canClick ? 1 : 0.5)};

  &:hover {
    background: ${({ theme: { palette }, canClick }) =>
      canClick ? palette.hover : 'transparent'};
  }
`
